<template>
  <div>
    <DatePicker v-model="value1" type="date" range placeholder="Tarikh" />
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  data() {
    return {
      value1: [],
      value2: [],
    };
  },
  components: { DatePicker },
};
</script>
